const initialState = {
  featuredFilter: false,
  keyword: "",
};

export default initialState;
